import jsPDF from "jspdf";
import "jspdf-autotable";

// define a generatePDF function that accepts an orders argument
const generateSubmissionsTableCsv = (reportData, inputData) => {

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let csvRows = [];

    const date = Date().split(" ");
    let today = new Date;
    let monthNum = (today.getMonth() + 1).toString().padStart(2, '0')

    // we use a date string to generate our filename.
    const dateStr = date[2] + "_" + monthNum + "_" + date[3];
    const generatedDate = monthNames[today.getMonth() + 1] + " " + date[2] + " " + date[3];
  

    csvRows.push(["Submissions Past Due Report"]);
    csvRows.push([monthNames[inputData.start_month - 1] + " " + inputData.start_year + " - " + monthNames[inputData.end_month - 1] + " " + inputData.end_year]);
    csvRows.push(['"Generated on: '+generatedDate+'"']);
    csvRows.push(["Company", "Owner", "Email", "Total Submissions Due", "Required Submissions"].join(','));

    reportData.forEach(report => {
        csvRows.push([
            '"'+report.name+'"',
            report.owner_name,
            report.owner_email,
            report.total_reports,
            report.report_dates
        ].join(','));
    });

    const csvData = csvRows.join('\n');
    download(csvData, `report_submissionsPastDue_${dateStr}`);
};

const download = (data, filename) => {
    // Create a Blob with the CSV data and type
    const blob = new Blob([data], { type: 'text/csv' });
    
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    
    // Create an anchor tag for downloading
    const a = document.createElement('a');
    
    // Set the URL and download attribute of the anchor tag
    a.href = url;
    a.download = filename+'.csv';
    
    // Trigger the download by clicking the anchor tag
    a.click();
}

export default generateSubmissionsTableCsv;